module.exports.getScrollbarWidth = () => {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

  document.body.appendChild(outer);

  const widthNoScroll = outer.offsetWidth;
  // force scrollbars
  outer.style.overflow = 'scroll';

  // add inner div
  const inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  const widthWithScroll = inner.offsetWidth;

  // remove divs
  outer.parentNode.removeChild(outer);

  return widthNoScroll - widthWithScroll;
};

module.exports.isDesktop = () => {
  if (window.screen.availWidth < 1400) {
    // console.log('laptop');
    return false;
  } else {
    // console.log('desktop');
    return true;
  }
};

module.exports.isPointInRect = (rect, x, y) => {
  // mitigators reduce accuracy but make it easier to 'click' a btn - they make the item's hover space 'bigger' than it actually is.
  // return (
  //   x >= rect.left - rect.xMitigator &&
  //   x <= rect.right + rect.xMitigator &&
  //   y >= rect.top - rect.yMitigator &&
  //   y <= rect.bottom + rect.yMitigator
  // );
  return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  // return x >= rect.left && x <= rect.right &
  // y >= rect.top && y <= rect.bottom;
};
